import { ROUTES } from 'constants/routes';
import {
  JYOTISHA_TOPIC_QUERY_KEY,
} from 'schools/parashari/utils/jyotishaTopicUrl';
import { MODULE_PARAM, TOPIC_PARAM } from 'shared/schoolLearn/useSchoolLearnNav';
import { getSchoolSearchMeta } from 'shared/search/schoolSearchConfig';
import type { GlobalSearchResult } from 'shared/search/types';

export function buildGlobalSearchResultHref(result: GlobalSearchResult): string {
  if (result.schoolSlug === 'parashari') {
    const base = ROUTES.PARASHARI_LEARN;
    return `${base}?${JYOTISHA_TOPIC_QUERY_KEY}=${encodeURIComponent(result.topicId)}`;
  }

  const route = getSchoolSearchMeta(result.schoolSlug).learnRoute;
  const params = new URLSearchParams();
  params.set(TOPIC_PARAM, result.topicId);
  if (result.moduleId) params.set(MODULE_PARAM, result.moduleId);
  return `${route}?${params.toString()}`;
}

export function getParashariInitialPage(result: GlobalSearchResult): string | undefined {
  if (result.schoolSlug !== 'parashari') return undefined;
  return 'jyotisha';
}

/** Dispatch Parashari topic-open events after navigation settles. */
export function dispatchParashariTopicOpen(result: GlobalSearchResult, searchQuery: string): void {
  if (result.schoolSlug !== 'parashari') return;
  const q = searchQuery.trim();
  const detail = {
    topicId: result.topicId,
    searchQuery: q.length >= 2 ? q : null,
  };

  window.setTimeout(() => {
    window.dispatchEvent(new CustomEvent('jyotisha-open-topic', { detail }));
  }, 120);
}
